module.exports = __webpack_public_path__ + "img/logo-scatbook-white.ca66ec5a.svg";